import { useState } from "react";
import { Button } from "antd";
import LineSpacer from "../../../../../../../components/LineSpacer";
import formatPrice from "../../../../../../../components/formatPrice";

const getSafePercent = (numerator, denominator) => {
	const num = Number(numerator);
	const den = Number(denominator);

	if (!Number.isFinite(num) || !Number.isFinite(den) || den === 0) {
		return "0.00";
	}

	return ((num / den) * 100).toFixed(2);
};

const WplywSumUp = ({ wplyw, personid, focusedPersonOwnId }) => {
	const isFocusedMode =
		focusedPersonOwnId !== null &&
		focusedPersonOwnId !== undefined &&
		String(focusedPersonOwnId).trim() !== "";
	const [open, setOpen] = useState(() => (isFocusedMode ? true : false));
	const normal = {
		fontWeight: "900",
		color: "black",
	};
	const deduction = {
		fontWeight: "900",
		color: "#ED0000",
	};
	const sum = {
		fontWeight: "900",
		color: "#52C41A",
	};
	return (
		<>
			<div
				style={{
					padding: "15px 20px",
					background: "#F9F9F9",
					marginTop: "20px",
					borderRadius: "5px",
					cursor: !open ? "pointer" : "default",
				}}
				onClick={() => (!open ? setOpen(true) : null)}
			>
				<div
					style={{
						display: "flex",
						gap: "20px",
						alignItems: "center",
						marginBottom: "15px",
					}}
				>
					Podsumowanie rozliczenia wpływu
					<LineSpacer />
					<Button onClick={() => setOpen(!open)}>
						{open ? "Zwiń" : "Rozwiń"}
					</Button>
				</div>
				{open && (
					<>
						<div
							style={{
								padding: "15px 15px",
								background: "white",
							}}
						>
							<div>
								Wpływ #
								{
									wplyw?.wplyw_data?.data?.msr_wplywy
										?.msr_wplywy_own_id
								}
							</div>
							<div
								style={{
									display: "flex",
									gap: "15px",
									flexWrap: "wrap",
									marginTop: "8px",
								}}
							>
								<div
									style={{
										padding: "5px",
										background: "#F9F9F9",
									}}
								>
									Kwota:{" "}
									<span style={normal}>
										{formatPrice(
											wplyw?.wplyw_data?.data?.msr_wplywy
												?.msr_wplywy_primary_amount,
										)}{" "}
										zł
									</span>
								</div>
								<div
									style={{
										padding: "5px",
										background: "#F9F9F9",
									}}
								>
									Kwota odliczenia wstępnego:{" "}
									<span style={deduction}>
										-
										{formatPrice(
											wplyw?.wplyw_data?.data?.msr_wplywy
												?.msr_wplywy_primary_deduction,
										)}{" "}
										zł
									</span>
								</div>
							</div>
						</div>
						<div
							style={{
								paddingLeft: "30px",
								marginTop: "15px",
								display: "grid",
								gap: "15px",
							}}
						>
							{wplyw?.wplyw_data?.data?.msr_wplywy?.msr_persons.map(
								(person) => {
									const personDeductionsSum =
										person.msr_reckonings.reduce(
											(sum, reck) =>
												sum +
												parseFloat(
													reck.msr_reckonings_deduction_from_income,
												) +
												reck.msr_deductions.reduce(
													(sum2, dd) =>
														sum2 +
														dd.msr_deductions_amount,
													0,
												),
											0,
										);
									const isFocusedPerson =
										isFocusedMode &&
										String(person.msr_persons_own_id) ===
											String(focusedPersonOwnId);
									const isDimmed =
										isFocusedMode && !isFocusedPerson;
									return (
										<div
											style={{
												padding: "15px 15px",
												background: "white",
												opacity: isDimmed ? 0.35 : 1,
											}}
										>
											<div>
												{person.msr_persons_name}{" "}
												{person.msr_persons_lastname} |
												#{person.msr_persons_own_id}
											</div>
											<div
												style={{
													display: "flex",
													gap: "15px",
													flexWrap: "wrap",
													marginTop: "8px",
												}}
											>
												<div
													style={{
														padding: "5px",
														background: "#F9F9F9",
													}}
												>
													Kwota:{" "}
													<span style={normal}>
														{formatPrice(
															person.msr_persons_amount,
														)}{" "}
														zł
													</span>
												</div>
												<div
													style={{
														padding: "5px",
														background: "#F9F9F9",
													}}
												>
													Odliczenia:{" "}
													<span style={deduction}>
														-
														{formatPrice(
															personDeductionsSum,
														)}{" "}
														zł [
														{getSafePercent(
															personDeductionsSum,
															person.msr_persons_amount,
														)}
														%]
													</span>
												</div>
												<div
													style={{
														padding: "5px",
														background: "#F9F9F9",
													}}
												>
													Suma:{" "}
													<span style={sum}>
														{formatPrice(
															person.msr_persons_amount -
																person.msr_reckonings.reduce(
																	(
																		sum,
																		reck,
																	) =>
																		sum +
																		parseFloat(
																			reck.msr_reckonings_deduction_from_income,
																		) +
																		reck.msr_deductions.reduce(
																			(
																				sum2,
																				dd,
																			) =>
																				sum2 +
																				dd.msr_deductions_amount,
																			0,
																		),
																	0,
																),
														)}{" "}
														zł
													</span>
												</div>
											</div>
											{(!isFocusedMode ||
												isFocusedPerson) && (
												<div
													style={{
														paddingLeft: "30px",
														marginTop: "15px",
														display: "grid",
														gap: "15px",
													}}
												>
													{person.msr_reckonings.map(
														(
															reckoning,
															reckoningIndex,
														) => (
															<div
																style={{
																	padding:
																		"15px 15px",
																	background:
																		"#F9F9F9",
																}}
															>
																<div>
																	#
																	{reckoningIndex +
																		1}{" "}
																	Rozliczenie
																	#
																	{
																		reckoning.msr_reckonings_own_id
																	}
																</div>
																<div
																	style={{
																		display:
																			"flex",
																		gap: "15px",
																		flexWrap:
																			"wrap",
																		marginTop:
																			"8px",
																	}}
																>
																	<div
																		style={{
																			padding:
																				"5px",
																			background:
																				"white",
																		}}
																	>
																		Kwota:{" "}
																		<span
																			style={
																				normal
																			}
																		>
																			{formatPrice(
																				reckoning.msr_reckonings_part_amount,
																			)}{" "}
																			zł
																		</span>
																	</div>
																	<div
																		style={{
																			padding:
																				"5px",
																			background:
																				"white",
																		}}
																	>
																		Prowizja:{" "}
																		<span
																			style={
																				deduction
																			}
																		>
																			-
																			{formatPrice(
																				reckoning.msr_reckonings_deduction_from_income,
																			)}{" "}
																			zł [
																			{getSafePercent(
																				reckoning.msr_reckonings_deduction_from_income,
																				reckoning.msr_reckonings_part_amount,
																			)}
																			%]
																		</span>
																	</div>
																	<div
																		style={{
																			padding:
																				"5px",
																			background:
																				"white",
																		}}
																	>
																		Numer
																		dokumentu:{" "}
																		{
																			reckoning.msr_reckonings_document
																		}
																	</div>
																	<div
																		style={{
																			padding:
																				"5px",
																			background:
																				"white",
																		}}
																	>
																		Suma po{" "}
																		<span
																			style={
																				deduction
																			}
																		>
																			*
																		</span>
																		odliczeniach:{" "}
																		<span
																			style={
																				sum
																			}
																		>
																			{formatPrice(
																				reckoning.msr_reckonings_part_amount -
																					reckoning.msr_reckonings_deduction_from_income -
																					reckoning.msr_deductions.reduce(
																						(
																							sum,
																							ded,
																						) =>
																							sum +
																							parseFloat(
																								ded.msr_deductions_amount,
																							),
																						0,
																					),
																			)}{" "}
																			zł
																		</span>
																	</div>
																</div>
																{reckoning
																	.msr_deductions
																	.length >
																	0 && (
																	<div
																		style={{
																			paddingLeft:
																				"30px",
																			marginTop:
																				"15px",
																			display:
																				"grid",
																			gap: "15px",
																		}}
																	>
																		<div
																			style={{
																				display:
																					"flex",
																				gap: "20px",
																				alignItems:
																					"center",
																			}}
																		>
																			<div>
																				<span
																					style={
																						deduction
																					}
																				>
																					*
																				</span>
																				Odliczenia
																			</div>
																			<LineSpacer></LineSpacer>
																		</div>
																		{reckoning.msr_deductions.map(
																			(
																				deductionItem,
																				deductionIndex,
																			) => (
																				<div
																					style={{
																						padding:
																							"15px 15px",
																						background:
																							"white",
																					}}
																				>
																					<div>
																						#
																						{reckoningIndex +
																							1}

																						.
																						{deductionIndex +
																							1}{" "}
																						Rozliczenie
																						#
																						{
																							deductionItem.msr_deductions_own_id
																						}
																					</div>
																					<div
																						style={{
																							display:
																								"flex",
																							gap: "15px",
																							flexWrap:
																								"wrap",
																							marginTop:
																								"8px",
																						}}
																					>
																						<div
																							style={{
																								padding:
																									"5px",
																								background:
																									"#F9F9F9",
																							}}
																						>
																							Kwota:{" "}
																							<span
																								style={
																									deduction
																								}
																							>
																								{formatPrice(
																									deductionItem.msr_deductions_amount,
																								)}{" "}
																								zł
																							</span>
																						</div>
																						<div
																							style={{
																								padding:
																									"5px",
																								background:
																									"#F9F9F9",
																							}}
																						>
																							Tytuł:{" "}
																							{
																								deductionItem.msr_deductions_title
																							}
																						</div>
																						<div
																							style={{
																								padding:
																									"5px",
																								background:
																									"#F9F9F9",
																							}}
																						>
																							Typ:{" "}
																							{
																								wplyw?.wplyw_data?.data?.default_values?.msr_deduction_types.find(
																									(
																										item,
																									) =>
																										item.msr_deduction_types_id ==
																										deductionItem.msr_deduction_types_id,
																								)
																									.label
																							}
																						</div>
																					</div>
																				</div>
																			),
																		)}
																	</div>
																)}
															</div>
														),
													)}
												</div>
											)}
										</div>
									);
								},
							)}
						</div>
					</>
				)}
			</div>
		</>
	);
};
export default WplywSumUp;
